"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductsSummaryFullStreamResponse = exports.getProductsSummaryFullStream = void 0;
const ndjson_1 = require("ndjson");
const routes_1 = require("../../routes");
const getProductsSummaryFullStream = (client) => async () => {
    const response = await (0, exports.getProductsSummaryFullStreamResponse)(client)();
    return response.data.pipe((0, ndjson_1.parse)());
};
exports.getProductsSummaryFullStream = getProductsSummaryFullStream;
const getProductsSummaryFullStreamResponse = (client) => async () => {
    const response = await client.get(routes_1.ENDPOINTS.GET_PRODUCTS_SUMMARY_FULL.path, {
        headers: {
            accept: 'application/x-ndjson',
        },
        responseType: 'stream',
    });
    return response;
};
exports.getProductsSummaryFullStreamResponse = getProductsSummaryFullStreamResponse;
